export default __webpack_public_path__ + "static/media/instagram.878c54f7.svg";